import React, {useEffect, useState} from "react";
import Layout from "../hocs/Layout";
import {connect} from "react-redux";
import {useParams} from "react-router-dom"
import hipermaxi from '../assets/image/portafolio/hipermaxi.png';

const ProdInformation = ({}) => {

    const {productoSlug} = useParams();
    console.log(productoSlug);

    const images = [
        hipermaxi,
        "https://i.postimg.cc/gj0NTmBk/Captura-de-pantalla-2025-04-09-165910.png",
        "https://i.postimg.cc/HnPBGRf0/Captura-de-pantalla-2025-04-16-161026.png",
        "https://i.postimg.cc/1RWWNVfg/Captura-de-pantalla-2025-04-26-110642.png",
        "https://i.postimg.cc/0ySZ3tZm/Captura-de-pantalla-2025-05-26-115010.png",
        "https://i.postimg.cc/YqhdN2Wd/Captura-de-pantalla-2025-05-26-115434.png",
        "https://i.postimg.cc/hP6p2F8c/Captura-de-pantalla-2025-06-09-233032.png"
    ];

    return (
        <Layout>
            <section>
                <div className="st-height-b100 st-height-lg-b80"></div>
                <div className="container">
                    <div className="st-section-heading st-style1">
                        <h4 className="st-section-heading-title">{productoSlug}</h4>
                        <h2 className="st-section-heading-subtitle">{productoSlug}</h2>
                    </div>
                    <div className="st-height-b25 st-height-lg-b25"></div>
                </div>
                <div className="container">
                    <div className="p-4">
                        <h2 className="text-2xl font-bold mb-4 text-center">Galería de Imágenes</h2>
                        <div className="columns-1 sm:columns-2 md:columns-3 gap-4 space-y-4">
                            {images.map((src, index) => (
                                <img
                                    key={index}
                                    src={src}
                                    alt={`img-${index}`}
                                    className="w-full rounded-lg break-inside-avoid"
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </section>

        </Layout>
    );
};


const mapStateToProps = state => ({})

export default connect(mapStateToProps, {})(ProdInformation)
